/* tslint:disable */
/* eslint-disable */
/**
 * Sports App Training Plans
 * API for the Sports App Training Plans
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeleteDeckDTO
 */
export interface DeleteDeckDTO {
    /**
     * 
     * @type {string}
     * @memberof DeleteDeckDTO
     */
    deckId: string;
}

/**
 * Check if a given object implements the DeleteDeckDTO interface.
 */
export function instanceOfDeleteDeckDTO(value: object): value is DeleteDeckDTO {
    if (!('deckId' in value) || value['deckId'] === undefined) return false;
    return true;
}

export function DeleteDeckDTOFromJSON(json: any): DeleteDeckDTO {
    return DeleteDeckDTOFromJSONTyped(json, false);
}

export function DeleteDeckDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeleteDeckDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'deckId': json['deckId'],
    };
}

export function DeleteDeckDTOToJSON(json: any): DeleteDeckDTO {
    return DeleteDeckDTOToJSONTyped(json, false);
}

export function DeleteDeckDTOToJSONTyped(value?: DeleteDeckDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'deckId': value['deckId'],
    };
}

